import Background from "./components/background/Background";
import Card from "./components/card/Card";

export function App() {
  return <div>
      <Card />
      <Background />
  </div>;
}
